const TEXTS = {
  ITEM_LIST_SELECT_ALl: 'Выбрать все',
  ITEM_LIST_SELECT_NONE: 'Сбросить',
  IN_OTHER_GROUP: 'Адрес принадлежит другой группе адресов',
  SELECTED: 'Выбрано: ',
};

export default TEXTS;
